const UINT32_RANGE = 0x1_0000_0000;

const secureUint32 = () => {
  const values = new Uint32Array(1);
  window.crypto.getRandomValues(values);
  return values[0];
};

export const secureRandomUnit = () => secureUint32() / UINT32_RANGE;

export const secureRandomInt = (maxExclusive) => {
  if (!Number.isSafeInteger(maxExclusive) || maxExclusive <= 0) {
    throw new RangeError("maxExclusive must be a positive safe integer");
  }

  return Math.floor(secureRandomUnit() * maxExclusive);
};

export const secureRandomId = () => {
  if (typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0"));

  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
    .slice(6, 8)
    .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
};
